import { Component } from 'react';
import PropTypes from 'prop-types';

import CONSTANTS from '../utils/Constants';

class InvisibleCaptcha extends Component {
	constructor(props) {
		super(props);

		this.state = {
			ready: false
		};
	}

	componentDidMount() {
		this.checkRecaptchaReady();
		this.scheduleReset();
	}

	componentWillUnmount() {
		this.unSchedule();
	}

	checkRecaptchaReady = () => {
		if (window.grecaptcha && window.grecaptcha.ready) {
			window.grecaptcha.ready(() => {
				this.setState({ ready: true });
				this.execute();
			});
		} else {
			// Retry in 100ms if reCAPTCHA not loaded yet
			setTimeout(this.checkRecaptchaReady, 100);
		}
	}

	unSchedule = () => {
		if(this.intervalId) {
			clearInterval(this.intervalId);
		}
	}

	scheduleReset = () => {
		this.intervalId = setInterval(() => this.execute(), CONSTANTS.TIMEOUTS.RECAPTCHA); 
	}

	execute = () => {
		if (window.grecaptcha && this.state.ready) {
			try {
				window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_ID, { 
					action: this.props.action || 'submit' 
				})
				.then(token => {
					if (this.props.verifyCallback) {
						this.props.verifyCallback(token);
					}
				})
				.catch(error => {
					console.error("reCAPTCHA execution error:", error);
				});
			} catch(error) {
				console.error("reCAPTCHA execute catch:", error);
			}
		} else {
			console.warn('reCAPTCHA not ready...');
		}
	}

	render() {
		// This component doesn't render any visible elements
		// reCAPTCHA v3 is invisible by design
		return null;
	}
}

InvisibleCaptcha.propTypes = {
	action: PropTypes.string,
	verifyCallback: PropTypes.func
};

InvisibleCaptcha.defaultProps = {
	action: 'submit'
};

export default InvisibleCaptcha;